module.exports = __webpack_public_path__ + "customer5.png?835646433d52edf8cb05e783d2d9cb92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer5.png
// module id = 117
// module chunks = 0